import React from "react";
import { FormBuilderPanelView } from "../FormBuilderPanelView";
import { useFormBuilderEditorContext } from "../../../formBuilderEditorContext";
import { useTranslation } from "react-i18next";
import { FormBuilderRowSettings } from "../../settings/row/FormBuilderRowSettings";
import { IFormBuilderRow } from "../../../model/formBuilderRow";

interface IFormBuilderPanelRowViewProps {
  row: IFormBuilderRow;
}

export function FormBuilderPanelRowView(props: IFormBuilderPanelRowViewProps) {
  const { row } = props;

  const { t } = useTranslation();

  const { formBuilderController } = useFormBuilderEditorContext();

  return (
    <FormBuilderPanelView
      header={{
        heading: t("Row"),
        onBack: () => formBuilderController.selectEntity({ selectedEntity: null }),
      }}
    >
      <FormBuilderRowSettings key={row.key} row={row} />
    </FormBuilderPanelView>
  );
}